import React from 'react';

const PluginInstallTableHeader = () => {
  return (
    <thead>
      {/* <tr>
        <th>Field</th>
        <th>
          Hard-Coded Value
          <br />
          <small>Fixed Value for all environments</small>
        </th>
        <th>OR</th>
        <th>
          Environment Constants
          <br />
          <small>Value will be changed according to (Preview, Publish, etc)</small>
        </th>
        <th>OR</th>
        <th>
          Tenant Field
          <br />
          <small>Value will be used according to tenant</small>
        </th>
      </tr> */}
    </thead>
  );
};

export default PluginInstallTableHeader;
